<div *ngIf="isMobile; else webLogin" class="full-container">
  <div class="sidebar" [class.open]="isSidebarOpen">
    <a class="sidebar-item" *ngIf="isCustomer()" (click)="openNotifications()">Notifications</a>
    <div class="divider" *ngIf="isCustomer()"></div>
    <a class="sidebar-item" *ngIf="isCustomer()" (click)="navigateTo('account')">Account</a>
    <div class="divider" *ngIf="isCustomer()"></div>
    <a class="sidebar-item" *ngIf="isCustomer()" (click)="navigateTo('history')">Bid History</a>
    <div class="divider" *ngIf="isCustomer()"></div>
    <a class="sidebar-item" *ngIf="isCustomer()" (click)="navigateTo('payments')">Payments</a>
    <div class="divider" *ngIf="isCustomer()"></div>
    <a class="sidebar-item" (click)="logout()">Logout</a>
  </div>
  <img class="bescom-back-arrow" *ngIf="showBescomLogoOnMarket" (click)="navigateTo('market')" src="assets/BESCOM_logo_small.png" alt="bescom-logo-mobile" />
  <img class="bescom-back-arrow" *ngIf="showBackArrow" (click)="navigateTo('market')" src="assets/BESCOM_logo_small.png" alt="back-button-mobile" />
  <img class="panchami-mobile-logo" src="assets/panchami_account_group.png" alt="hygge_hamburger_menu" (click)="toggleSidebar()" />
  <div class="notification-status-mobile" *ngIf="isUnread">
    <div class="notification-number-mobile">{{ numberOfNotifications }}</div>
  </div>
</div>

<ng-template #webLogin>
  <div class="profile-container">
    <div class="user-name">{{ hygge_name }}</div>
    <div class="profile">
      <div class="dropdown">
        <div class="user-info">
          <img height="40px" src="assets/user.png" class="dropbtn" (click)="toggleDropdown()" />
          <div class="notification-status" *ngIf="isUnread">
            <div class="notification-number">{{ numberOfNotifications }}</div>
          </div>
        </div>
        <div class="dropdown-content" *ngIf="isDropdownOpen">
          <a class="dropdown-item" *ngIf="isCustomer()" (click)="openNotifications()">Notifications</a>
          <div class="divider" *ngIf="isCustomer()"></div>
          <a class="dropdown-item" *ngIf="isCustomer()" (click)="navigateTo('account')">Account</a>
          <div class="divider" *ngIf="isCustomer()"></div>
          <a class="dropdown-item" *ngIf="isCustomer()" (click)="navigateTo('history')">Bid History</a>
          <div class="divider" *ngIf="isCustomer()"></div>
          <a class="dropdown-item" *ngIf="isCustomer()" (click)="navigateTo('user-wallet')">Wallet</a>
          <div class="divider" *ngIf="isCustomer()"></div>
          <a class="dropdown-item" (click)="logout()">Logout</a>
        </div>
      </div>
    </div>
  </div>
</ng-template>